import React from "react";
import { useNavigate } from "react-router-dom";

const BillingCanceledPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-[#E5E7EB] p-8 text-center">
        <div className="h-14 w-14 rounded-full bg-[#FEF3C7] flex items-center justify-center mx-auto mb-4 text-2xl">
          —
        </div>
        <h1 className="text-xl font-bold text-[#111827] mb-2">
          Checkout canceled
        </h1>
        <p className="text-sm text-[#6B7280] mb-6">
          No charges were made. You can subscribe anytime from the upgrade
          prompt or team settings.
        </p>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="w-full py-3 rounded-xl bg-[#111827] text-white text-sm font-semibold hover:bg-[#1F2937]"
        >
          Back to app
        </button>
      </div>
    </div>
  );
};

export default BillingCanceledPage;
